import script from "./Logo.vue?vue&type=script&setup=true&lang=js"
export * from "./Logo.vue?vue&type=script&setup=true&lang=js"

import "./Logo.vue?vue&type=style&index=0&id=b76701a8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b76701a8"]])

export default __exports__